import * as common from './common.json';

const hr = {
    common,
};

export default hr;
